import React from 'react'

import {type Option} from './AddFilterButton'
import {AddFilterButton} from './AddFilterButton'

type AddFilterProps<T> = {
  onChange: (newValue: string[]) => void
  'data-test-id': string
  values: string[]
  options: T[]
  translate: (key: string) => string
}

export function AddFilter<T extends string>({
  values,
  onChange,
  options,
  'data-test-id': dataTestId,
  translate
}: AddFilterProps<T>) {
  const dropDownOptions: Option<T>[] = React.useMemo(
    () =>
      options.map((option) => ({
        value: option,
        label: translate(`shiftEvent.addFilter.${option}`)
      })),
    [translate, options]
  )

  return (
    <AddFilterButton
      data-test-id={dataTestId}
      id="events-filter-bar-add-filter-button"
      buttonLabel={translate('shiftEvent.label.addFilter')}
      options={dropDownOptions}
      values={values}
      onChange={onChange}
    />
  )
}
